import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "tag",
  "use": "tag-usage",
  "viewBox": "0 0 20 17.19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 17.19\" id=\"tag\"><title>tag</title><path d=\"M19.53,1.4H13.07a.46.46,0,0,0-.33.13L2.59,11.48a.47.47,0,0,0,0,.67L9,18.46a.47.47,0,0,0,.66,0L19.86,8.52A.47.47,0,0,0,20,8.18V1.87A.47.47,0,0,0,19.53,1.4ZM19,7.95,9.36,17.34,3.72,11.8l9.59-9.38H19Z\" transform=\"translate(0 -1.4)\" /><path d=\"M1.28,11.8l9.56-9.35a.47.47,0,0,0,0-.67l-.07-.07a.47.47,0,0,0-.66,0l-10,9.76a.47.47,0,0,0,0,.67l6.25,6.12a.47.47,0,0,0,.65,0l.07-.07a.47.47,0,0,0,0-.67Z\" transform=\"translate(0 -1.4)\" /><path d=\"M15.51,7.81a2,2,0,1,0-2-2A2,2,0,0,0,15.51,7.81Zm0-3a1,1,0,1,1-1,1A1,1,0,0,1,15.51,4.82Z\" transform=\"translate(0 -1.4)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/tag.svg
// module id = j6Ty
// module chunks = 268